import React from 'react';
import { Section } from '../settingsPrimitives';
import { useAuthStore } from '../../store/authStore';
import { formatCloudRemovalDate, readCloudRemoval } from '../../plans/cloudState';

/**
 * Settings › Privacy & Data: the date the account's cloud copy will be deleted,
 * while the server has one (`removal_scheduled_at`, 90-day retention, owner
 * 16.10.2026). Nothing is rendered without a date: no guessed deadline.
 */
const CloudRemovalSection = ({ t, language }) => {
  const user = useAuthStore((s) => s.user);
  const { scheduledAt } = readCloudRemoval(user?._usage, user);
  const date = formatCloudRemovalDate(scheduledAt, language);
  if (!date) return null;
  return (
    <Section title={t('settings.cloudRemovalSection')}>
      <div className="privacy-feedback privacy-feedback--error" role="status" data-testid="cloud-removal-date">
        {t('cloudLocal.removal.messageDated', { date })}
      </div>
    </Section>
  );
};

export default CloudRemovalSection;
